module.exports = __webpack_public_path__ + "static/media/galerija_2023 (7).be20b8ba.jpg";